export const LOAD_PROPERTIES = "loadProperties";
export const SET_PROPERTIES = "setProperties";

export default {
  state: {
    properties: []
  },

  getters: {
    properties(state) {
      return state.properties;
    }
  },

  actions: {
    [LOAD_PROPERTIES](state, data) {
      state.commit(SET_PROPERTIES, data);
    }
  },

  mutations: {
    [SET_PROPERTIES](state, properties) {
      state.properties = properties;
    }
  }
};
